import { createContext } from 'react'
import dayjs, { OpUnitType } from 'shared/dayjs'
import {
  defaultDateRange,
  predefinedDateRanges
} from '../../components/utils/predefinedDateRanges'
import {
  AnalyticsFilter,
  AnalyticsFilterWithGroups
} from '../../graphql/private/PrivateSchemaTypes'
import { SetAnalyticsQuery } from './analyticsFilters/useAnalyticsFilterFromQuery'
import { SetDateFilterQuery } from '../../components/common/dateFilter/dateFilter.types'

export type AnalyticsFilterType = {
  includeAdmins: boolean
  includeArchived: boolean
  includeDrafts: boolean
  workspaceIds: number[] | null
  pathwayIds: number[] | null
  groupIds: number[] | null
  topicId?: number | null
  userId?: number | null
  campaignIds?: number[] | null
  page: number
  search: string
}

export type AnalyticsContextType = {
  filter: AnalyticsFilterType
  filterAsQueryVariables: AnalyticsFilterWithGroups | AnalyticsFilter
  changeFilter: SetAnalyticsQuery
  changeDateFilter: SetDateFilterQuery
}

export const AnalyticsFilterDefaultValues = {
  from: dayjs()
    .subtract(defaultDateRange.amount, defaultDateRange.unit as OpUnitType)
    .startOf('day')
    .toDate(),
  to: dayjs().endOf('day').toDate(),
  includeAdmins: true,
  includeDrafts: false,
  includeArchived: false,
  workspaceIds: null,
  pathwayIds: null,
  groupIds: null,
  campaignIds: null,
  period: predefinedDateRanges[1],
  page: 1,
  search: ''
}

export const AnalyticsContext = createContext<AnalyticsContextType>({
  filter: AnalyticsFilterDefaultValues,
  changeFilter: () => {},
  changeDateFilter: () => {},
  filterAsQueryVariables: null as any
})
